import React, { useState, useMemo, useEffect } from "react";
import "../CSS/SemuaTenagaKesehatan.css";
import { FaSearch, FaFileAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function TenagaKesehatan() {
  const [query, setQuery] = useState("");
  const [filterProfession, setFilterProfession] = useState("");
  const [tenaga, setTenaga] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();


  // Fetch data dari backend
  useEffect(() => {
    const fetchTenaga = async () => {
      try {
        const res = await fetch("https://api-tibismart.tifpsdku.com/api/all");
        if (!res.ok) throw new Error("Gagal fetch data tenaga kesehatan");
        const data = await res.json();
        console.log("Response:", data);
        console.log("Array?", Array.isArray(data));
        setTenaga(data);
      } catch (err) {
        console.error("Error fetching tenaga kesehatan:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTenaga();
  }, []);

  // Filter profesi
  const professions = useMemo(() => {
    const s = new Set(tenaga.map((d) => d.profession));
    return ["All", ...Array.from(s)];
  }, [tenaga]);

  // Filter dan search
  const filtered = useMemo(() => {
    return tenaga.filter((row) => {
      const q = query.trim().toLowerCase();
      if (q) {
        const match =
          row.name.toLowerCase().includes(q) ||
          (row.email || "").toLowerCase().includes(q) ||
          (row.phone || "").includes(q);
        if (!match) return false;
      }
      if (filterProfession && filterProfession !== "All") {
        if (row.profession !== filterProfession) return false;
      }
      return true;
    });
  }, [query, filterProfession, tenaga]);


  // ================= PAGINATION =================
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filtered.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filtered.length / rowsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [query, filterProfession]);

  // Delete tenaga kesehatan
  const handleDelete = async (id, name) => {
    const konfirmasi = window.confirm(`Apakah yakin ingin menghapus tenaga kesehatan ${name}?`);
    if (!konfirmasi) return;

    try {
      const res = await fetch(`https://api-tibismart.tifpsdku.com/api/delete/${id}`, {
        method: "DELETE"
      });

      if (!res.ok) throw new Error("Gagal menghapus data");

      // Update state agar UI ter-refresh
      setTenaga((prev) => prev.filter((t) => t.id !== id));
      alert(`Tenaga kesehatan ${name} berhasil dihapus`);
    } catch (err) {
      console.error("Error deleting tenaga:", err);
      alert("Gagal menghapus tenaga kesehatan");
    }
  };

  const handleVerifikasi = async (id) => {
    try {
      const res = await fetch(
        `https://api-tibismart.tifpsdku.com/api/verifikasi/${id}`,
        {
          method: "PUT",
        }
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data.message);

      alert("Akun berhasil diverifikasi.");

      setTenaga((prev) =>
        prev.map((item) =>
          item.id === id
            ? { ...item, status_verifikasi: "TERVERIFIKASI" }
            : item
        )
      );
    } catch (err) {
      alert(err.message);
    }
  };

  const handleTolak = async (id) => {
    try {
      const res = await fetch(
        `https://api-tibismart.tifpsdku.com/api/tolak/${id}`,
        {
          method: "PUT",
        }
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data.message);

      alert("Akun berhasil ditolak.");

      setTenaga((prev) =>
        prev.map((item) =>
          item.id === id
            ? { ...item, status_verifikasi: "DITOLAK" }
            : item
        )
      );
    } catch (err) {
      alert(err.message);
    }
  };

  // Detail click
  const handleDetailClick = (id) => {
    navigate(`/HalamanDetailTenagaKesehatan/${id}`);
  };

  if (loading) return <p>Loading data...</p>;

  console.log("tenaga =", tenaga);
  console.log("filtered =", filtered);

  return (
    <div className="data-tenaga-page">
      <div className="content-tenaga">
        <div className="filter-section">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Cari tenaga kesehatann..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>

          <select
            value={filterProfession}
            onChange={(e) => setFilterProfession(e.target.value)}
          >
            {professions.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>
        </div>


        <div className="table-wrapper">
          <table className="table-tenaga">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Tenaga Medis</th>
                <th>No. TLP</th>
                <th>Email</th>
                <th>Profesi</th>
                <th>Jumlah Screening</th>
                <th>Status</th>
                <th>Verifikasi</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.map((r, idx) => (
                <tr key={r.id}>
                  <td>{indexOfFirstRow + idx + 1}</td>
                  <td>{r.name}</td>
                  <td>{r.phone}</td>
                  <td>{r.email}</td>
                  <td>{r.profession}</td>
                  <td>{r.jumlah_screening}</td>
                  <td>
                    <span
                      className={
                        r.status_verifikasi === "TERVERIFIKASI"
                          ? "badge-verifikasi"
                          : r.status_verifikasi === "DITOLAK"
                            ? "badge-ditolak"
                            : "badge-menunggu"
                      }
                    >
                      {r.status_verifikasi}
                    </span>
                  </td>

                  <td>
                    {r.status_verifikasi === "PENDING" && (
                      <>
                        <button
                          className="btn-verifikasi"
                          onClick={() => handleVerifikasi(r.id)}
                        >
                          Verifikasi
                        </button>

                        <button
                          className="btn-tolak"
                          onClick={() => handleTolak(r.id)}
                        >
                          Tolak
                        </button>
                      </>
                    )}
                  </td>
                  <td className="aksi">
                    <button
                      className="btn-detail"
                      onClick={() => handleDetailClick(r.id)}
                    >
                      <FaFileAlt className="icon-detail" /> Detail
                    </button>
                    <button
                      className="btn-hapuspasien"
                      onClick={() => handleDelete(r.id, r.name)}
                    >
                      Hapus
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>


        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Prev
          </button>

          {(() => {
            const pages = [];
            const maxVisible = 5;

            let start = Math.max(1, currentPage - 2);
            let end = Math.min(totalPages, start + maxVisible - 1);

            if (end - start < maxVisible - 1) {
              start = Math.max(1, end - maxVisible + 1);
            }

            if (start > 1) {
              pages.push(
                <button key={1} onClick={() => setCurrentPage(1)}>
                  1
                </button>
              );

              if (start > 2) {
                pages.push(<span key="dots1">...</span>);
              }
            }

            for (let i = start; i <= end; i++) {
              pages.push(
                <button
                  key={i}
                  className={currentPage === i ? "active" : ""}
                  onClick={() => setCurrentPage(i)}
                >
                  {i}
                </button>
              );
            }

            if (end < totalPages) {
              if (end < totalPages - 1) {
                pages.push(<span key="dots2">...</span>);
              }

              pages.push(
                <button
                  key={totalPages}
                  onClick={() => setCurrentPage(totalPages)}
                >
                  {totalPages}
                </button>
              );
            }

            return pages;
          })()}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>

        <p className="footer-textsemua">© 2025 TibiSmart. All rights reserved.</p>
      </div>
    </div>
  );
}

export default TenagaKesehatan;
